var map = {
	"./Btn.vue": 6857,
	"./Changelog.vue": 4313,
	"./Foot.vue": 7616,
	"./Input.vue": 8023,
	"./Legal.vue": 7189,
	"./Loader.vue": 5113,
	"./Mark.vue": 15,
	"./Topbar.vue": 2018,
	"./Wordmark.vue": 9521
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 443;